import React, { useEffect, useState } from "react";
import { useLang } from "../context/LangContext";
import { t } from "../lib/i18n";
import { api } from "../lib/api";
import { Calendar } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Booking() {
  const { lang } = useLang();
  const [services, setServices] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "", date: "", time: "", location: "", notes: "" });
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      setBusy(true);
      await api.post("/booking", form);
      setSubmitted(true);
      toast.success(lang === "gr" ? "Η κράτηση καταχωρήθηκε!" : "Booking received!");
      setForm({ name: "", email: "", phone: "", service: "", date: "", time: "", location: "", notes: "" });
    } catch {
      toast.error(lang === "gr" ? "Αποτυχία" : "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20" data-testid="booking-page">
      <div className="grid lg:grid-cols-2 gap-16">
        <div>
          <div className="label-tag mb-4 slash">{t("sections.booking_eyebrow", lang)}</div>
          <h1 className="display-font text-5xl sm:text-7xl font-black uppercase leading-[0.9] tracking-tighter">
            {lang === "gr" ? <>Κράτηση <span className="neon-text">ραντεβού.</span></> : <>Lock in <span className="neon-text">a date.</span></>}
          </h1>
          <p className="text-gray-300 mt-6 max-w-xl">
            {lang === "gr"
              ? "Πείτε μας την ημερομηνία και την υπηρεσία που χρειάζεστε. Θα επιβεβαιώσουμε εντός 24 ωρών."
              : "Tell us the date and service you need. We confirm within 24 hours."}
          </p>

          <div className="card-dark p-6 mt-10 max-w-md">
            <Calendar size={28} weight="duotone" className="text-[#ccff00] mb-3" />
            <div className="display-font font-bold text-lg">{lang === "gr" ? "Διαθεσιμότητα" : "Availability"}</div>
            <p className="text-gray-400 text-sm mt-2">
              {lang === "gr" ? "Δεχόμαστε κρατήσεις 7 ημέρες την εβδομάδα. Σε περίοδο αιχμής, προτείνουμε ≥2 εβδομάδες πριν." : "We take bookings 7 days a week. For peak season, book ≥2 weeks ahead."}
            </p>
          </div>
        </div>

        <form onSubmit={submit} className="card-dark p-8" data-testid="booking-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input required placeholder={t("forms.name", lang)} className="input-dark" value={form.name} onChange={change("name")} data-testid="booking-name" />
            <input required type="email" placeholder={t("forms.email", lang)} className="input-dark" value={form.email} onChange={change("email")} data-testid="booking-email" />
            <input placeholder={t("forms.phone", lang)} className="input-dark" value={form.phone} onChange={change("phone")} data-testid="booking-phone" />
            <select required className="input-dark" value={form.service} onChange={change("service")} data-testid="booking-service">
              <option value="">{t("forms.service", lang)}</option>
              {services.map((s) => (
                <option key={s.id} value={s.title.en || s.title.gr}>{s.title[lang] || s.title.en}</option>
              ))}
              <option value="Other">{lang === "gr" ? "Άλλο" : "Other"}</option>
            </select>
            <input required type="date" className="input-dark" value={form.date} onChange={change("date")} data-testid="booking-date" />
            <input type="time" className="input-dark" value={form.time} onChange={change("time")} data-testid="booking-time" />
            <input placeholder={t("forms.location", lang)} className="input-dark sm:col-span-2" value={form.location} onChange={change("location")} data-testid="booking-location" />
            <textarea placeholder={t("forms.notes", lang)} className="input-dark sm:col-span-2 min-h-[120px]" value={form.notes} onChange={change("notes")} data-testid="booking-notes" />
          </div>
          <button type="submit" disabled={busy} className="btn-primary mt-6 w-full justify-center" data-testid="booking-submit">
            {busy ? "..." : t("cta.confirm_book", lang)}
          </button>
          {submitted && <div className="text-[#ccff00] mono-font text-xs mt-4">{lang === "gr" ? "// ΕΛΗΦΘΗ — ΘΑ ΕΠΙΚΟΙΝΩΝΗΣΟΥΜΕ" : "// RECEIVED — WE'LL BE IN TOUCH"}</div>}
        </form>
      </div>
    </div>
  );
}
